const $logo = $('.m-logo-slider__img');
const $modalContainer = $('.m-logo-slider__modal-container');
const $modalTitle = $('.m-logo-modal__title');
const $modalTitleSrc = $('.m-logo-slider__mTitle');
const $modalIframe = $('.m-logo-slider__modal-img');
const $modalLinksSrc = $('.m-logo-slider__mLinks');
const $modalLinks = $('.m-logo-slider__modal-links');

const activeModifier = 'm-logo-slider__img--active';


$('.m-logo-slider').on('click', '.m-logo-slider__img', function () {
  const $target = $(this);
  if (!$(this).parent().hasClass('download')) {
    // reset all
    $modalContainer.hide();
    $modalTitle.empty();
    $modalIframe.empty();
    $modalIframe.attr('data-ext', '');
    $modalLinks.empty();
    $logo.removeClass(activeModifier);

    // apply for current
    const title = $target.closest($('.m-logo-slider__inner')).find($modalTitleSrc).html();
    const $logoModal = $target
      .closest($('.m-logo-slider__inner'))
      .find($('.m-logo-modal'));
    const img = $logoModal.html();
    const imgExt = $logoModal.attr('data-ext');
    const links = $target.closest($('.m-logo-slider__inner')).find($modalLinksSrc).html();
    if (title || img || links) {
      $modalTitle.html(title);
      $modalIframe.html(img);
      $modalIframe.attr('data-ext', imgExt);
      $modalLinks.html(links);
      $modalContainer.css('display', 'block');
    }
  }
});


$modalContainer.on('click', '.js-close-modal', function () {
  $modalTitle.empty();
  $modalIframe.empty();
  $modalContainer.hide();
});


$('.m-logo-slider__inner').matchHeight({
  byRow: false
});

$.fn.matchHeight._beforeUpdate = function(event, groups) {
  $('.m-logo-slider__img-obj').removeClass('m-logo-slider__img-obj--ie');
}

$.fn.matchHeight._afterUpdate = function(event, groups) {
  $('.m-logo-slider__img-obj').addClass('m-logo-slider__img-obj--ie');
}
